// removed by extract-text-webpack-plugin
module.exports = {"payment_new":"payment_new__Es0yM"};


//////////////////
// WEBPACK FOOTER
// ./routes/payments/new/style.scss
// module id = KUsL
// module chunks = 3